<template>
  <mini-card :value="'$'+$store.getters.totalPayouts()" subtitle="Payouts" :previousValue="'$'+$store.getters.totalPayoutsPrevious()">
    <div slot="header" class="icon-warning">
      <i class="fad fa-money-check-edit-alt text-primary"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span><i class="far fa-clock mr-2"/>Paid monthly</span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
import MiniCard from './MiniCard.vue'
export default {
  name: 'Payouts-MiniCard',
  components: {
    MiniCard
  },
  data() {
    return {}
  },
  methods: {
    managePayouts () {
      this.$router.push('/dashboard/payouts')
    },
    addPayout () {
      this.$store.dispatch('openModal', { name: 'Payout', mode: 'Create', object: new Payout({type: Payout._type.MANUAL.value}) })
    }
  }
}
</script>

<style>

</style>